import React from 'react';
import Container from 'evcharging/components/Container';
import Section from 'evcharging/containers/layout/Section';
import Box from 'evcharging/components/Box';
import useTheme from 'evcharging/hooks/useTheme';
import useI18n from 'evcharging/hooks/useI18n';
import { css } from '@emotion/css';

const CuttingEdge = () => {
  const theme = useTheme();
  const { t } = useI18n();

  return (
    <Section background={'dark'} padding={'130px 0'}>
      <Container>
        <Box
          fontSize={24}
          fontWeight={500}
          lineHeight={'140%'}
          maxWidth={1060}
          margin={'0 auto'}
          textAlign={'center'}
          color={'#fff'}
          className={css({
            [theme.breakpoints.mobile.down]: {
              fontSize: 18,
            },
          })}
        >
          {t('rebates.edge')}
        </Box>
      </Container>
    </Section>
  );
};

export default CuttingEdge;
